module.exports = __webpack_public_path__ + "static/img/language.cbf94f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/language.png
// module id = j12L
// module chunks = 1